import { documentationActions } from '../../actions/constant';

const {
  GET_THERAPIST_INFO_REQUEST,
  GET_THERAPIST_INFO_SUCCESS,
  GET_THERAPIST_INFO_FAILURE,
  GET_THERAPIST_INFO_RESET,
  GET_THERAPIST_INFO_LOADING,
} = documentationActions;

const intitialstate: object = {
  response: null,
  getTherapistInfo: false,
  loading: false,
};

export const getTherapistInfoReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPIST_INFO_SUCCESS: {
      return {
        ...state,
        getTherapistInfo: true,
        response: action.payload,
        loading: false,
      };
    }

    case GET_THERAPIST_INFO_FAILURE:
      return {
        ...state,
        getTherapistInfo: false,
        response: action.payload,
        loading: false,
      };

    case GET_THERAPIST_INFO_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_THERAPIST_INFO_RESET:
      return intitialstate;

    default:
      return state;
  }
};
